import { createSlice } from "@reduxjs/toolkit";

import { getModelList, addModelList, updateModelList, deleteModelList } from "./thunk";

export const initialState = {
    modelList: {
        content: []
    },
    errors: {}
};

const ModelSlice = createSlice({
    name: 'Model',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(getModelList.fulfilled, (state: any, action: any) => {
            state.modelList.content = action.payload;
        });
        builder.addCase(getModelList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(addModelList.fulfilled, (state: any, action: any) => {
            console.log(action.payload)
            state.modelList.content.unshift(action.payload);
        });
        builder.addCase(addModelList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(updateModelList.fulfilled, (state: any, action: any) => {
            state.modelList.content = state.modelList.content.map((category: any) =>
                category.id === action.payload.id
                    ? { ...category, ...action.payload }
                    : category
            );
        });

        builder.addCase(updateModelList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(deleteModelList.fulfilled, (state: any, action: any) => {
            state.modelList.content = state.modelList.content.filter(
                (modelList: any) => modelList.id !== action.payload
            );
            console.log(action.payload)
        });
        builder.addCase(deleteModelList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default ModelSlice.reducer;